module.exports = __webpack_public_path__ + "img/equity_icon8.ffab5eaf.png";